var PROFILE_LOAD_SUCCESS = 'PROFILE_LOAD_SUCCESS';
var PROFILE_AVATAR_DELETE_SUCCESS = 'PROFILE_AVATAR_DELETE_SUCCESS';
var PROFILE_AVATAR_SELECT_SUCCESS = 'PROFILE_AVATAR_SELECT_SUCCESS';
var PROFILE_AVATAR_UPLOAD_SUCCESS = 'PROFILE_AVATAR_UPLOAD_SUCCESS';
var PROFILE_PHONE_VERIFY_SUCCESS = 'PROFILE_PHONE_VERIFY_SUCCESS';
var PROFILE_LOAD_URL = '/user/profile/load';
var PROFILE_SAVE_URL = '/user/profile/save';
var PROFILE_AVATAR_DELETE_URL = '/user/avatar/delete';
var PROFILE_AVATAR_SELECT_URL = '/user/avatar/select';
var PROFILE_AVATAR_UPLOAD_URL = '/user/avatar/upload';
var PROFILE_EXTERNAL_APP_LINK_URL = '/user/external-app/link';
var PROFILE_EXTERNAL_APP_UNLINK_URL = '/user/external-app/unlink';
var REDUCER_PROFILE_NAME = 'userProfile';
var USER_PROFILE_MAIN_URL = '/user/profile';
var GOTO_TELEGRAM_BTN_HIDDEN_TIME = 60 * 5 * 1000;
var COOKIE_NAME = 'linkAppFollowBotClicked';
export { PROFILE_LOAD_SUCCESS, PROFILE_AVATAR_DELETE_SUCCESS, PROFILE_AVATAR_SELECT_SUCCESS, PROFILE_AVATAR_UPLOAD_SUCCESS, PROFILE_PHONE_VERIFY_SUCCESS, PROFILE_LOAD_URL, PROFILE_SAVE_URL, PROFILE_AVATAR_DELETE_URL, PROFILE_AVATAR_SELECT_URL, PROFILE_AVATAR_UPLOAD_URL, PROFILE_EXTERNAL_APP_LINK_URL, PROFILE_EXTERNAL_APP_UNLINK_URL, REDUCER_PROFILE_NAME, USER_PROFILE_MAIN_URL, GOTO_TELEGRAM_BTN_HIDDEN_TIME, COOKIE_NAME };